import React from 'react';

interface NumberFormatterProps {
  number: number;
}

const NumberFormatter: React.FC<NumberFormatterProps> = ({ number }) => {
  const formatter = Intl.NumberFormat('en', { notation: 'compact' });
  const formattedNumber = formatter.format(number);

  return <span>{formattedNumber}</span>;
};

export default NumberFormatter;
